import "./ShowAll.scss";
import { useEffect, useState } from "react";
import { getCategory, getSubcategory } from "../../../services/products";
import { useCookies } from "react-cookie";
import { useNavigate, useParams } from "react-router-dom";
import InfoMessage from "../../InfoMessage/InfoMessage";
import { useTranslation } from "react-i18next";
import { getCombos } from "../../../services/meals";

export default function ShowAll({
  active,
  id,
  setShowAllId,
  isSubcategory,
  cart,
  setCart,
  showMessage,
  setShowMessage,
  isActive,
  setActive,
}) {
  const { categoryId, subcategoryId } = useParams();
  const { t } = useTranslation();
  const [cookie] = useCookies(["access_token"]);
  const navigate = useNavigate();
  const [category, setCategory] = useState();
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    let timer;
    if (showTooltip) {
      timer = setTimeout(() => {
        setShowTooltip(false);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [showTooltip]);

  useEffect(() => {
    id === "combos"
      ? getCombos(cookie.access_token).then((res) =>
          setCategory({ name: "Комбо", meals: res.data }),
        )
      : subcategoryId === undefined
        ? getCategory(
            localStorage.getItem("activeMenu"),
            cookie.access_token,
          ).then((res) => setCategory(res))
        : getSubcategory(id, cookie.access_token).then((res) =>
            setCategory(res),
          );
  }, [id, active]);

  const [convertedPrices, setConvertedPrices] = useState([]);

  useEffect(() => {
    if (!Array.isArray(category?.meals) || category.meals.length === 0) return;

    const fetchConvertedPrices = async () => {
      const prices = await Promise.all(
        category?.meals.map((product) =>
          product?.price
            ? (Number(product.price) * 1.95583).toFixed(2)
            : Promise.resolve(null),
        ),
      );
      setConvertedPrices(prices);
    };

    fetchConvertedPrices();
  }, [category]);

  return (
    <div className="show-all">
      {showMessage && <InfoMessage></InfoMessage>}
      <div className="top">
        {window.screen.width >= 767 && isSubcategory ? (
          <div
            className="back"
            onClick={() => {
              setShowAllId(null);
              navigate(`/menu/category/${categoryId}`);
            }}
          >
            <div className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="8"
                viewBox="0 0 23 8"
                fill="none"
              >
                <path
                  d="M5.83337 4H22.1667"
                  stroke="#343434"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M0.357288 3.78563L4.62174 1.22696C5.15496 0.907026 5.83333 1.29112 5.83333 1.91295V6.08705C5.83333 6.70888 5.15496 7.09297 4.62174 6.77304L0.357289 4.21437C0.195454 4.11727 0.195454 3.88273 0.357288 3.78563Z"
                  fill="#343434"
                />
              </svg>
            </div>

            <div className="text">
              <p>Обратно към Категориите</p>
            </div>
          </div>
        ) : (
          window.screen.width <= 767 &&
          isSubcategory && (
            <div
              className="back"
              onClick={() => {
                setShowAllId(null);
                navigate(`/menu/category/${categoryId}`);
              }}
            >
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23"
                  height="8"
                  viewBox="0 0 23 8"
                  fill="none"
                >
                  <path
                    d="M5.83337 4H22.1667"
                    stroke="#343434"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M0.357288 3.78563L4.62174 1.22696C5.15496 0.907026 5.83333 1.29112 5.83333 1.91295V6.08705C5.83333 6.70888 5.15496 7.09297 4.62174 6.77304L0.357289 4.21437C0.195454 4.11727 0.195454 3.88273 0.357288 3.78563Z"
                    fill="#343434"
                  />
                </svg>
              </div>
            </div>
          )
        )}
        <div className="title">{t(category?.name)}</div>
      </div>
      <div className="all-items">
        {category?.meals?.map((product, index) => {
          return (
            <div className="single-item">
              <div
                className="item-image"
                onClick={() => {
                  subcategoryId !== undefined
                    ? String(id) === "combos"
                      ? (window.location.href = `/menu/category/${categoryId}/subcategory/combos/product/${product.id}`)
                      : (window.location.href = `/menu/category/${categoryId}/subcategory/${subcategoryId}/product/${product.id}`)
                    : (window.location.href = `/menu/category/${categoryId}/product/${product.id}`);
                }}
              >
                {product?.images[0]?.url ? (
                  <img src={product?.images[0]?.url} alt={product.name} />
                ) : (
                  <img
                    src="https://alexfish-static.s3.eu-north-1.amazonaws.com/missing.svg"
                    alt={product.name}
                  />
                )}
              </div>
              <div
                className="title"
                onClick={() => {
                  subcategoryId !== undefined
                    ? String(id) === "combos"
                      ? (window.location.href = `/menu/category/${categoryId}/subcategory/combos/product/${product.id}`)
                      : (window.location.href = `/menu/category/${categoryId}/subcategory/${subcategoryId}/product/${product.id}`)
                    : (window.location.href = `/menu/category/${categoryId}/product/${product.id}`);
                }}
              >
                <p>
                  {product.name}
                  <span> {product?.weight && `${product.weight}г`}</span>
                </p>
              </div>
              {product?.promoPrice === null || id === "combos" ? (
                <div className="price">
                  <p>
                    {Number(product.price).toFixed(2)} {"€/"}
                    {convertedPrices.length > index &&
                    convertedPrices[index] !== null
                      ? convertedPrices[index] + t("lv")
                      : "Converting..."}
                  </p>
                </div>
              ) : (
                <div className="price">
                  <p className="new">
                    {Number(product.promoPrice).toFixed(2)} {"€/"}
                  </p>
                  <p className="old">
                    {Number(product.price).toFixed(2)} {"€/"}
                  </p>
                </div>
              )}
              <div className={`add-to-cart ${!isActive ? "disabled" : ""}`}>
                {!isActive && (
                  <p
                    className={`${
                      showTooltip ? "visible" : ""
                    } sushi-available`}
                  >
                    {t("sushi-available")}
                  </p>
                )}
                <button
                  disabled={!isActive}
                  onMouseOver={() => !isActive && setShowTooltip(true)}
                  onMouseLeave={() => !isActive && setShowTooltip(false)}
                  onClick={() => {
                    if (typeof window.gtag === "function") {
                      window.gtag("event", "add_to_cart", {
                        currency: "EUR",
                        value: product?.price,
                        items: [product],
                      });
                    } else {
                      console.error("gtag is not defined!");
                    }
                    setShowMessage(true);
                    if (id !== "combos") {
                      let existing = false;
                      cart.map((item) => {
                        if (
                          item.id === product.id &&
                          item.weight === product.weight
                        ) {
                          existing = true;
                        }
                      });
                      if (existing) {
                        setCart((currentCart) =>
                          currentCart.map((item) =>
                            item.id === product.id
                              ? { ...item, amount: item.amount + 1 }
                              : item,
                          ),
                        );
                      } else {
                        setCart([
                          ...cart,
                          {
                            ...product,
                            added: [],
                            removed: [],
                            amount: 1,
                            price:
                              product?.promoPrice !== null
                                ? product?.promoPrice
                                : product?.price,
                            singlePrice:
                              product?.promoPrice !== null
                                ? product?.promoPrice
                                : product?.price,
                            isCombo: false,
                            weight: product?.weight || product?.minWeight,
                          },
                        ]);
                      }
                    } else {
                      let existing = false;
                      cart.map((item) => {
                        if (item.id === product.id) {
                          existing = true;
                        }
                      });
                      if (existing) {
                        setCart((currentCart) =>
                          currentCart.map((item) =>
                            item.id === product.id
                              ? { ...item, amount: item.amount + 1 }
                              : item,
                          ),
                        );
                      } else {
                        setCart([
                          ...cart,
                          {
                            ...product,
                            amount: 1,
                            price: product?.price,
                            singlePrice: product?.price,
                            isCombo: true,
                          },
                        ]);
                      }
                    }
                  }}
                >
                  {t("add")}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
